@if (!isDagrofa) {
  <app-basket-overview></app-basket-overview>
}
@if (isDagrofa) {
  <app-meny-basket-overview></app-meny-basket-overview>
}
